import React from "react";
import { Plus, Trash2 } from "lucide-react";

export default function MultipleChoiceBlockEditor({ block, onChange }) {
    if (!block) {
        return <div className="text-sm text-gray-500">بلاک انتخاب نشده است.</div>;
    }

    const config = block.config && typeof block.config === "object" ? block.config : {};
    const options = Array.isArray(config.options) ? config.options.filter(Boolean) : [];
    const correctOptionIds = Array.isArray(config.correctOptionIds) ? config.correctOptionIds : [];

    const updateConfig = (patch) => {
        onChange({
            ...block,
            config: {
                ...config,
                ...patch,
            },
        });
    };

    const updateOption = (optionId, patch) => {
        const nextOptions = options
            .map((opt) => (opt && opt.id === optionId ? { ...opt, ...patch } : opt))
            .filter(Boolean);

        updateConfig({ options: nextOptions });
    };

    const addOption = () => {
        updateConfig({
            options: [
                ...options,
                { id: crypto.randomUUID(), text: "" },
            ],
        });
    };

    const deleteOption = (optionId) => {
        const nextOptions = options.filter((opt) => opt && opt.id !== optionId);
        const nextCorrectOptionIds = correctOptionIds.filter((id) => id !== optionId);

        updateConfig({
            options: nextOptions,
            correctOptionIds: nextCorrectOptionIds,
        });
    };

    const toggleCorrectOption = (optionId) => {
        const exists = correctOptionIds.includes(optionId);
        const nextCorrectOptionIds = exists
            ? correctOptionIds.filter((id) => id !== optionId)
            : [...correctOptionIds, optionId];

        updateConfig({ correctOptionIds: nextCorrectOptionIds });
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium mb-1">متن سوال</label>
                <textarea
                    className="w-full p-3 border rounded-lg bg-gray-50"
                    value={config.prompt || ""}
                    onChange={(e) => updateConfig({ prompt: e.target.value })}
                    placeholder="سوال را وارد کنید..."
                />
            </div>

            <div className="space-y-2">
                <div className="flex items-center justify-between">
                    <label className="block text-sm font-medium">گزینه‌ها</label>
                    <button
                        type="button"
                        onClick={addOption}
                        className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-blue-600 text-white text-sm"
                    >
                        <Plus size={14} />
                        افزودن گزینه
                    </button>
                </div>

                {options.map((opt, index) => {
                    if (!opt) return null;

                    return (
                        <div
                            key={opt.id}
                            className="flex items-center gap-2 p-2 border rounded-lg bg-white"
                        >
                            <input
                                type="checkbox"
                                checked={correctOptionIds.includes(opt.id)}
                                onChange={() => toggleCorrectOption(opt.id)}
                            />

                            <input
                                className="flex-1 p-2 border rounded-lg bg-gray-50"
                                value={opt.text || ""}
                                onChange={(e) => updateOption(opt.id, { text: e.target.value })}
                                placeholder={`گزینه ${index + 1}`}
                            />

                            <button
                                type="button"
                                onClick={() => deleteOption(opt.id)}
                                className="p-2 rounded hover:bg-red-50 text-red-600"
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    );
                })}

                {options.length === 0 && (
                    <div className="text-sm text-gray-500 p-3 border rounded-lg bg-gray-50">
                        هنوز گزینه‌ای اضافه نشده است.
                    </div>
                )}
            </div>
        </div>
    );
}
